/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settingsnav_Billingmanagement2Inputs */

const zh_settingsnav_billingmanagement2 = /** @type {(inputs: Settingsnav_Billingmanagement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账单管理`)
};

const en_settingsnav_billingmanagement2 = /** @type {(inputs: Settingsnav_Billingmanagement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing Management`)
};

const es_settingsnav_billingmanagement2 = /** @type {(inputs: Settingsnav_Billingmanagement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de facturación`)
};

/**
* | output |
* | --- |
* | "Billing Management" |
*
* @param {Settingsnav_Billingmanagement2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const settingsnav_billingmanagement2 = /** @type {((inputs?: Settingsnav_Billingmanagement2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingsnav_Billingmanagement2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_settingsnav_billingmanagement2(inputs)
	if (locale === "en") return en_settingsnav_billingmanagement2(inputs)
	return es_settingsnav_billingmanagement2(inputs)
});
export { settingsnav_billingmanagement2 as "settingsNav_billingManagement" }